import React from 'react';
import styles from './styles.module.css';
import { Button } from '../Button';

export interface HorizontalInfoActionCardProps {
  subtitle?: string;
  title: string;
  onInfoClick?: () => void;
}

export const HorizontalInfoActionCard = ({
  subtitle,
  title,
  onInfoClick,
}: HorizontalInfoActionCardProps) => {
  return (
    <div className={styles.card}>
      <div className={styles.wrapTitle}>
        {subtitle && (
          <div className={styles.wrapSubTitle}>
            <span className={styles.infoMarker} />
            <p className={styles.subTitle}>{subtitle}</p>
          </div>
        )}
        <h3 className={styles.title}>{title}</h3>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          label="Mais informações"
          onClick={onInfoClick}
          size="none"
          variant="text"
          aria-label="Mais informações"
          className={styles.cardLink}
        />
      </div>
    </div>
  );
};
